import { useQuery } from 'react-query';

import { getTemplatesRoute } from '@features/digitalOnboarding/api/constants';
import axiosInstance from '@server/axiosInstance';

export const useGetTemplates = () => {
  const templatesKey = 'templates';

  const { data: templatesData, isLoading: isLoadingTemplates } = useQuery({
    queryKey: [templatesKey],
    queryFn: () => axiosInstance.get(getTemplatesRoute).then((res) => res.data),
  });

  return {
    templatesData,
    isLoadingTemplates,
  };
};
